(() => {
  const init = (root) => {
    if (!root || root.dataset.slipknutReady === "true") return;
    root.dataset.slipknutReady = "true";

    const frames = [...root.querySelectorAll("[data-slipknut-frame]")];
    const mediaButtons = [...root.querySelectorAll("[data-slipknut-media-button]")];
    const choices = [...root.querySelectorAll("[data-slipknut-variant-choice]")];
    const idInput = root.querySelector("[data-slipknut-variant]");
    const price = root.querySelector("[data-slipknut-price]");
    const sku = root.querySelector("[data-slipknut-sku]");
    const selection = root.querySelector("[data-slipknut-selection]");
    const submit = root.querySelector("[data-slipknut-submit]");
    const submitLabel = root.querySelector("[data-slipknut-submit-label]");

    const showMedia = (index) => {
      frames.forEach((frame) => frame.classList.toggle("is-active", frame.dataset.slipknutFrame === String(index)));
      mediaButtons.forEach((button) => button.classList.toggle("is-active", button.dataset.slipknutMediaButton === String(index)));
    };
    mediaButtons.forEach((button) => button.addEventListener("click", () => showMedia(button.dataset.slipknutMediaButton)));

    const syncVariant = (choice) => {
      choices.forEach((item) => item.closest(".slipknut__pack")?.classList.toggle("is-selected", item === choice));
      if (idInput) idInput.value = choice.value;
      if (price) price.textContent = choice.dataset.price || "";
      if (sku) sku.textContent = choice.dataset.sku || "";
      if (selection) selection.textContent = choice.dataset.title || "";
      const available = choice.dataset.available === "true";
      if (submit) submit.disabled = !available;
      if (submitLabel) submitLabel.textContent = available ? "ADD SLIPKNUTS TO CART" : "CURRENTLY UNAVAILABLE";
      const url = new URL(window.location.href);
      url.searchParams.set("variant", choice.value);
      window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
    };
    choices.forEach((choice) => choice.addEventListener("change", () => syncVariant(choice)));
    const checked = choices.find((choice) => choice.checked) || choices[0];
    if (checked) syncVariant(checked);
  };
  const initAll = (scope = document) => scope.querySelectorAll("[data-slipknut-product]").forEach(init);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => initAll());
  else initAll();
  document.addEventListener("shopify:section:load", (event) => initAll(event.target));
})();
